import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect, useRef } from 'react';
import { FaEdit, FaRegClock, FaUser } from 'react-icons/fa';
import { MdDateRange, MdDelete, MdWhatsapp, MdLocationOn, MdComment } from 'react-icons/md';
import { FiTarget } from 'react-icons/fi';
import { BsDownload } from 'react-icons/bs';
import { HiDotsVertical } from "react-icons/hi";
import { FaPhone, FaWpforms } from "react-icons/fa6";
import { IoSearchOutline } from 'react-icons/io5';
// Custom components
import * as React from 'react';
import { Button, Form, Toast, ToastContainer } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';

import FileUpdate from './FileUpdate';
import DeleteModal from './DeleteModal';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { addBulkData, exportAppointmentDetail, getPatientExcelData, leadGet, searchLead, viewLead } from '../../../redux/actions/Files.action';
import { allCounselorDetail } from '../../../redux/actions/Files.action';
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate } from 'react-router-dom';
import userPhoto from '../../../assets/img/user.png'
import moment from 'moment';
import { fetchAllEmailTemplates, getMessage, getSetting } from '../../../redux/actions/Setting.action';
import Modal from 'react-bootstrap/Modal';
// import './styles.css';
import * as XLSX from "xlsx";
import { FaEye } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import AddLead from './CreateModal';

// Add responsive styles
const responsiveStyles = `
  /* Styles for all screen sizes */
  .mobile-only-button {
    display: none !important;
  }
  
  @media only screen and (max-width: 768px) {
    .mobile-only-button {
      display: inline-flex !important;
    }
  }
`;
export default function CreateTable() {
  const [updateModal, setUpdateModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [updateId, setUpdateId] = useState('');
  const [leadId, setLeadId] = useState([]);
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const dispatch = useDispatch();
  const getFile = useSelector((state) => state.files);
  const setting = useSelector((state) => state.setting);
  const managers = getFile?.allCounselor?.data?.CounselorsData || [];
  const [leadStatuses, setLeadStatuses] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [checked, setChecked] = useState(false);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [selectedMobileNumber, setselectedMobileNumber] = useState();
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
    startDate: '',
    endDate: '',
    status: '',
    managerId: ''
  });
  const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false);
  const [whatsappInputType, setWhatsappInputType] = useState('');
  const [whatsappDropdownSelection, setWhatsappDropdownSelection] = useState('');
  const [whatsAppMessage, setWhatsAppMessage] = useState([])
  const [otherMessage, setOtherMessage] = useState('');
  const [errors, setErrors] = useState({ dropdown: '', other: '' });
  const [selectedLeadName, setSelectedLeadName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [selectedEmailAddress, setSelectedEmailAddress] = useState('');
  const [emailDropdownSelection, setEmailDropdownSelection] = useState('');
  const [customEmailMessage, setCustomEmailMessage] = useState('');
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const fileInputRef = useRef(null);
  const [showToast, setShowToast] = useState(false);
  const openEmailModal = (email, firstName, lastName) => {
    setIsEmailModalOpen(true);
    setSelectedEmailAddress(email);
    setSelectedLeadName(`${firstName} ${lastName}`);
  };
  const handleAddLead = () => {
    setShowAddModal(true);
  };

  const handleOpenUploadModal = () => {
    setShowUploadModal(true);
  };

  const handleCloseUploadModal = () => {
    setShowUploadModal(false);
  };

  const handleTriggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
    setShowUploadModal(false);
  };

  const handleDownloadTemplate = () => {
    // Example: Download a blank Excel template
    const headers = [
      'firstName', 'middleName', 'lastName', 'gender', 'phoneNumber', 'city'
    ];
    const ws = XLSX.utils.aoa_to_sheet([headers]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Template');
    XLSX.writeFile(wb, 'Lead_Upload_Template.xlsx');
    setShowUploadModal(false);
  };
  const closeEmailModal = () => {
    setIsEmailModalOpen(false);
    setEmailDropdownSelection('');
    setCustomEmailMessage('');
  };
  useEffect(() => {
    dispatch(fetchAllEmailTemplates()).then((res) => {
      if (res?.status === 200) {
        setEmailTemplates(res?.data?.data || []);
      }
    });
  }, [dispatch]);
  const handleSendEmail = () => {
    let messageToSend = '';
    let subject = '';

    if (emailDropdownSelection === 'custom') {
      subject = 'Custom Message';
      messageToSend = customEmailMessage;
    } else {
      const selectedTemplate = emailTemplates.find(
        (t) => t._id === emailDropdownSelection
      );
      subject = selectedTemplate?.title || 'No Subject';
      messageToSend = selectedTemplate?.description || '';
    }

    if (!messageToSend) return alert("Message content is empty.");

    const mailtoLink = `mailto:${selectedEmailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(messageToSend)}`;
    window.location.href = mailtoLink;

    closeEmailModal();
  };


  const handleSend = () => {
    let hasError = false;
    const newErrors = { dropdown: '', other: '' };

    if (!whatsappDropdownSelection) {
      newErrors.dropdown = 'Please select a message option.';
      hasError = true;
    }

    if (whatsappDropdownSelection === 'other' && !otherMessage.trim()) {
      newErrors.other = 'Please enter your custom message.';
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;

    let formattedNumber = selectedMobileNumber;
    // if (!formattedNumber.startsWith('91')) {
    //   formattedNumber = `91${formattedNumber}`;
    // }

    let messageToSend = '';
    if (whatsappDropdownSelection === 'other') {
      messageToSend = otherMessage;
      setOtherMessage('');
    } else {
      const selectedMsgObj = whatsAppMessage.find((msg) => msg._id === whatsappDropdownSelection);
      messageToSend = selectedMsgObj?.description || '';
      setOtherMessage('');
    }

    const encodedMessage = encodeURIComponent(messageToSend);
    const whatsappURL = `https://api.whatsapp.com/send?phone=${formattedNumber}&text=${encodedMessage}`;

    window.open(whatsappURL, '_blank');
    closeWhatsappModal();
  };

  const openWhatsappModal = (mobileNumber, firstName, lastName) => {
    setIsWhatsappModalOpen(true);
    setselectedMobileNumber(mobileNumber);
    setSelectedLeadName(`${firstName} ${lastName}`);
  };

  const closeWhatsappModal = () => {
    setIsWhatsappModalOpen(false);
    setWhatsappDropdownSelection('');
    setOtherMessage('');
    setErrors({ dropdown: '', other: '' });
  };

  const handlePhoneClick = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const limits = {
    page: mainPage,
    limit: rowsPerPage,
    managerId: searchDefault.managerId || ''
  }

  useEffect(() => {
    dispatch(getSetting())
    dispatch(getMessage())
      .then((res) => {
        if (res?.status == 200) {
          setWhatsAppMessage(res?.data?.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [])

  useEffect(() => {
    if (Array.isArray(setting?.getSetting?.leadStatuses?.leadStatuses) && setting?.getSetting?.leadStatuses?.leadStatuses.length > 0) {
      setLeadStatuses(setting.getSetting.leadStatuses?.leadStatuses || []);
    }
  }, [setting]);


  const getBackgroundColor = (leadStatusName) => {
    const status = leadStatuses.find(status =>
      status.title.toLowerCase() === leadStatusName.toLowerCase()
    );

    return status ? status.backgroundColor : "transparent";
  };

  const navigate = useNavigate();

  const handleDropdownToggle = (isOpen, id) => {
    if (isOpen) {
      setActiveDropdownId(id);
    }
  };

  const handleNavigate = (res) => {
    navigate('/master/addAppointment', { state: { showModal: true, userData: res } });
  }

  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setChecked(true);
      setLeadId((prev) => {
        if (!prev.includes(id)) {
          return [...prev, id];
        }
        return prev;
      });
    } else {
      setChecked(false);
      setLeadId((prev) => prev.filter((lead) => lead !== id));
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;

    setSearchDefault((prev) => {
      const updatedSearchDefault = {
        ...prev,
        [name]: value,
        page: mainPage,
        limit: rowsPerPage
      };
      const queryParams = new URLSearchParams(updatedSearchDefault).toString();
      dispatch(
        searchLead(queryParams)
      );
      return updatedSearchDefault;
    });
  };

  const handleStatusChange = (e) => {
    const { value } = e.target;

    setSearchDefault((prev) => {
      const updatedSearchDefault = {
        ...prev,
        status: value,
        page: mainPage,
        limit: rowsPerPage
      };
      const queryParams = new URLSearchParams(updatedSearchDefault).toString();
      dispatch(searchLead(queryParams));
      return updatedSearchDefault;
    })
  }

  const handleManagerChange = (e) => {
    const managerId = e.target.value;
    setSearchDefault(prev => ({
      ...prev,
      managerId: managerId
    }));
    setMainPage(1);
  };



  const updateToggle = (id) => {

    setUpdateModal(!updateModal);
    // dispatch(viewLead(id?._id))
    if (!updateModal) {
      setUpdateId(id);
    } else {
      setUpdateId('');
      const updatedSearchParams = {
        ...searchDefault,
        page: mainPage,
        limit: rowsPerPage,
        search: searchQuery,
        startDate: searchDefault.startDate,
        endDate: searchDefault.endDate,
        status: searchDefault.status,
        // counselorAssignName: formValues.type || ''
      };

      const queryParams = new URLSearchParams(updatedSearchParams).toString();
      dispatch(searchLead(queryParams));
    }
  };

  const viewToggle = () => { setViewModal(!viewModal); };

  const handleView = (id) => {
    dispatch(viewLead(id))
    navigate(`/master/viewLead/${id}`)
  }

  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };

  const deleteData = (id) => {
    setDeleteModal(!deleteModal);
    setLeadId([id])
  }

  const handleSearch = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: 1,
      limit: rowsPerPage,
      startDate: searchDefault.startDate,
      endDate: searchDefault.endDate,
      status: searchDefault.status,
    };
    setSearchDefault(newSearchParams);
    setIsLoading(true);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    dispatch(searchLead(queryParams))
      .finally(() => setIsLoading(false));
  };

  const ChangeMainPage = (selected) => {
    const newPage = parseInt(selected.selected) + 1;
    setMainPage(newPage);

    const updatedSearchParams = {
      ...searchDefault,
      page: newPage,
      search: searchQuery,
      startDate: searchDefault.startDate,
      endDate: searchDefault.endDate,
      status: searchDefault.status,
    };

    setSearchDefault(updatedSearchParams);

    const queryParams = new URLSearchParams(updatedSearchParams).toString();
    dispatch(searchLead(queryParams));
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);

    const updatedSearchParams = {
      ...searchDefault,
      page: 1,
      limit: newRowsPerPage,
    };

    setSearchDefault(updatedSearchParams);

    const queryParams = new URLSearchParams(updatedSearchParams).toString();
    dispatch(searchLead(queryParams));
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    getFile?.getAllLead?.data?.totalCount / postPerPage,
  );

  useEffect(() => {
    const { search, startDate, endDate, status, managerId } = searchDefault;
    const isFilterApplied = search || startDate || endDate || status || managerId;

    const updatedSearchParams = {
      ...searchDefault,
      page: mainPage,
      limit: rowsPerPage
    };

    const queryParams = new URLSearchParams(updatedSearchParams).toString();

    if (isFilterApplied) {
      dispatch(searchLead(queryParams));
    } else {
      dispatch(leadGet(limits));
    }
  }, [mainPage, rowsPerPage, searchDefault]);

  const handleExport = () => {
    setIsLoading(true);
    const data = {
      search: searchDefault.search,
      startDate: searchDefault.startDate,
      endDate: searchDefault.endDate,
      status: searchDefault.status,
      managerId: searchDefault.managerId,
    };
    dispatch(getPatientExcelData(data)).finally(() => setIsLoading(false));
    setIsExporting(true);
  };

  useEffect(() => {
    if (isExporting && getFile?.getPatientExcel?.data?.PatientData?.length) {
      const exportData = getFile.getPatientExcel.data.PatientData.map((res) => ({
        firstName: res?.firstName || "",
        lastName: res?.lastName || "",
        phoneNumber: res?.phoneNumber || "",
        email: res?.email || "",
        city: res?.city || "",
        leadFrom: res?.leadFrom || "",
        counselorAssign: res?.counselorAssign?.name || "",
        leadStatus: res?.leadStatus || "",
        date: moment(res?.createdAt).format("DD/MM/YYYY") || "",
        time: res?.createdAt ? formatTime(res?.createdAt) : "",
        remark: res?.remark || "",
      }));

      // Generate HTML table with CSS
      const htmlContent = `
        <html>
          <head>
            <style>
              table {
                border-collapse: collapse;
                width: 100%;
                font-family: Arial, sans-serif;
              }
              th, td {
                border: 1px solid #ddd;
                padding: 8px;
                text-align: left;
              }
              th {
                background-color: #03367f;
                color: #ffffff;
                font-weight: bold;
              }
            </style>
          </head>
          <body>
            <table>
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Phone Number</th>
                  <th>Email</th>
                  <th>Location</th>
                  <th>Lead From</th>
                  <th>Lead Assign</th>
                  <th>Lead Status</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                ${exportData
          .map(
            (row) => `
                      <tr>
                        <td>${row.firstName}</td>
                        <td>${row.lastName}</td>
                        <td>${row.phoneNumber}</td>
                        <td>${row.email}</td>
                        <td>${row.city}</td>
                        <td>${row.leadFrom}</td>
                        <td>${row.counselorAssign}</td>
                        <td>${row.leadStatus}</td>
                        <td>${row.date}</td>
                        <td>${row.time}</td>
                        <td>${row.remark}</td>
                      </tr>
                    `
          )
          .join('')}
              </tbody>
            </table>
          </body>
        </html>
      `;

      // Create Blob and download
      const blob = new Blob([htmlContent], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'User_Data.xlsx'; // Note: .xls extension
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      // Reset exporting flag
      setIsExporting(false);
    }
  }, [getFile?.getPatientExcel?.data?.PatientData, isExporting]);


  const formatTime = (dateString) => {
    const date = new Date(dateString);

    // Add 5 hours and 30 minutes
    date.setUTCHours(date.getUTCHours() + 5);
    date.setUTCMinutes(date.getUTCMinutes() + 30);

    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours || 12;
    const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutesFormatted} ${ampm}`;
  };


  const handleFileUpload = async (event) => {
    setUploadError('');
    const file = event.target.files[0];
    if (!file) return;
    // Read file as array buffer
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    const uploadedHeaders = (json[0] || []).map(h => (h || '').toString().trim().toLowerCase());
    const requiredHeaders = ['firstname', 'middlename', 'lastname', 'gender', 'phonenumber', 'city'];
    const isValid = requiredHeaders.length === uploadedHeaders.length && requiredHeaders.every((h, i) => h === uploadedHeaders[i]);
    if (!isValid) {
      const errorMsg = 'Excel headers do not match the required format. Please use the provided template.';
      setUploadError(errorMsg);
      setShowToast(true);
      event.target.value = '';
      return;
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("bulkUploadFile", file);
    dispatch(addBulkData(formData, limits, searchDefault.status))
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      {isLoading && (
        <div className="loaderAdd">
          <div className="loader_line"><img src={localStorage.getItem('logo')} className="w-[200px]" /></div>
        </div>
      )}
      <style>{responsiveStyles}</style>
      <div className="mt-[120px] d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-end mb-5 gap-3 flex-wrap">
        {/* Left Filters */}
        <div className="d-flex flex-column flex-lg-row gap-2 w-100 w-lg-auto mb-3 mb-lg-0">
          {/* Start Date */}
          <div className='w-100 w-lg-auto mb-2 mb-lg-0'>
            <label className="text-sm">Start Date</label>
            <input
              type="date"
              name="startDate"
              value={searchDefault.startDate}
              onChange={handleDateChange}
              className="w-100 w-lg-75 outline-none !border-b"
            />
          </div>
          {/* End Date */}
          <div className="w-100 w-lg-auto mb-2 mb-lg-0">
            <label className="text-sm">End Date</label>
            <input
              type="date"
              name="endDate"
              value={searchDefault.endDate}
              onChange={handleDateChange}
              className="w-100 w-lg-75 outline-none !border-b"
            />
          </div>
          {/* Status */}
          <div className='w-100 w-lg-auto'>
            <label className="text-sm block mb-1">Status</label>
            <select
              onChange={handleStatusChange}
              value={searchDefault.status}
              className='w-100 border-b outline-none bg-transparent'
            >
              <option value="" disabled>Select Lead Status</option>
              {setting?.getSetting?.leadStatuses?.leadStatuses?.map((status) => (
                <option key={status._id} value={status.title}>{status.title}</option>
              ))}
            </select>
          </div>
          {/* Manager Filter */}
          {localStorage.getItem('type') !== 'Manager' && (
            <div className='w-100 w-lg-auto'>
              <label className="text-sm block mb-1">Manager</label>
              <select
                onChange={(e) => handleManagerChange(e)}
                value={searchDefault.managerId || ''}
                className='w-100 border-b outline-none bg-transparent'
              >
                <option value="">Select Manager</option>
                {managers.map((manager) => (
                  <option key={manager._id} value={manager._id}>{manager.name}</option>
                ))}
              </select>
            </div>
          )}

        </div>


        {/* Right Actions: single line on large screen */}
        <div className="d-flex flex-column flex-lg-row align-items-stretch justify-between align-items-lg-center gap-2 w-100 w-lg-auto">
          {/* Search */}
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 w-sm-100 w-md-100 w-lg-auto">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={searchQuery}
              onChange={handleSearch}
              className="w-100 outline-none"
              placeholder="Search..."
            />
          </div>

          <div className='d-flex flex-wrap gap-2'>
            {/* Download */}
            <Button
              className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
              onClick={handleExport}
            >
              <BsDownload className="me-2" />
              Download
            </Button>


            {localStorage.getItem('type') !== 'Lead' && (
              <>
                <Button
                  onClick={handleAddLead}
                  className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
                >
                  <IoMdAdd className="me-2" />
                  Add Lead
                </Button>
                {/* Upload Button triggers modal */}
                <div onClick={handleOpenUploadModal} style={{ display: 'inline-block' }}>
                  <div className="!bg-theme-dark text-white py-[6px] px-[12px] rounded cursor-pointer fw-bold d-flex align-items-center justify-content-center">
                    <IoMdAdd className="me-2" />
                    Upload
                  </div>
                </div>
                {/* Hidden file input for upload */}
                <input
                  type="file"
                  className="d-none"
                  accept=".xlsx"
                  ref={fileInputRef}
                  onChange={handleFileUpload}
                />
              </>
            )}
            {/* Upload Modal */}
            <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
              <Toast bg="danger" onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
                <Toast.Header>
                  <strong className="me-auto">Upload Error</strong>
                </Toast.Header>
                <Toast.Body className="text-white">{uploadError}</Toast.Body>
              </Toast>
            </ToastContainer>
            <Modal show={showUploadModal} onHide={handleCloseUploadModal}>
              <Modal.Header closeButton>
                <Modal.Title>Upload/Download Options</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="d-flex flex-column gap-3">
                  <Button
                    className="!bg-theme-dark border-0 px-4"
                    onClick={handleTriggerFileInput}
                  >
                    Upload Excel File
                  </Button>
                  <Button
                    className="border !border-theme-dark bg-transparent !text-theme-dark px-4"
                    style={{ borderWidth: 2 }}
                    onClick={handleDownloadTemplate}
                  >
                    Download Excel Format
                  </Button>
                  {uploadError && (
                    <div className="alert alert-danger mt-2 mb-0" style={{ fontSize: '0.95rem' }}>{uploadError}</div>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseUploadModal}>
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Delete All (if checked) */}
            {checked && (
              <Button
                onClick={() => deleteToggle(leadId)}
                className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
              >
                Delete All
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className="mt-[50px] mb-4">
        <div className='d-flex flex-column flex-lg-row mb-4 gap-2 gap-lg-0 align-items-stretch align-items-lg-center'>
          <h2 className='mb-0 fw-bold'>Lead List</h2>
          <div className='ms-lg-auto border-r pe-3 me-3'>
            Total Records: <span className='text-success border-b border-success'>{getFile?.getAllLead?.data?.totalCount || 0}</span>
          </div>
          <div className="d-flex align-items-center gap-2">
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="ms-2 border rounded-md focus:outline-none"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
          </div>
        </div>

        {/* Table Format */}
        <div className="overflow-x-auto bg-white rounded-xl shadow-lg border border-gray-100">
          <table className="w-full text-left border-collapse table-auto">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200 text-gray-600 text-xs uppercase font-bold tracking-wider">
                <th className="py-3 px-4">Name</th>
                <th className="py-3 px-4">Phone</th>
                <th className="py-3 px-4">Status</th>
                <th className="py-3 px-4">Date & Time</th>
                <th className="py-3 px-4">Lead From</th>
                <th className="py-3 px-4">Location</th>
                <th className="py-3 px-4">Assignee & Remark</th>
                <th className="py-3 px-4 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 text-sm">
              {getFile?.getAllLead?.data?.PatientData?.length > 0 ? (
                getFile?.getAllLead?.data?.PatientData?.map((res) => (
                  <tr key={res._id} className="hover:bg-blue-50/40 transition-colors">
                    <td className="py-3 px-4 font-semibold text-blue-900">
                      <div className="flex items-center gap-2.5">
                        <img
                          src={res.photo || userPhoto}
                          alt="avatar"
                          className="w-8 h-8 rounded-full object-cover border border-gray-200 shadow-sm"
                          onError={(e) => { e.target.onerror = null; e.target.src = userPhoto; }}
                        />
                        <span>{res.firstName} {res.lastName}</span>
                      </div>
                    </td>
                    <td className="py-3 px-4 text-gray-700">
                      <div className="flex items-center gap-1">
                        <FaPhone className="text-blue-500 text-xs" />
                        <span>{res.phoneNumber || '-'}</span>
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <span
                        className="inline-block px-2.5 py-1 rounded-full text-xs font-semibold text-white shadow-sm"
                        style={{
                          background: res.leadStatus
                            ? getBackgroundColor(res.leadStatus.trim().toLowerCase())
                            : 'gray',
                        }}
                      >
                        {res.leadStatus || '-'}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-gray-600">
                      <div>{res.createdAt ? moment(res.createdAt).format('DD/MM/YYYY') : '-'}</div>
                      {res.createdAt && (
                        <div className="text-xs text-gray-400">{formatTime(res.createdAt)}</div>
                      )}
                    </td>
                    <td className="py-3 px-4 text-gray-600 font-medium">{res.leadFrom || '-'}</td>
                    <td className="py-3 px-4 text-gray-600">{res.city || ''}{res.country ? `, ${res.country}` : ''}</td>
                    <td className="py-3 px-4 text-gray-600 max-w-[200px]">
                      {res?.counselorAssign?.name && (
                        <div className="text-xs font-semibold text-emerald-700">Assign: {res.counselorAssign.name}</div>
                      )}
                      <div className="text-xs truncate" title={res.remark}>{res.remark || '-'}</div>
                    </td>
                    <td className="py-3 px-4 text-center">
                      <div className="flex items-center justify-center gap-2.5">
                        <button
                          className="text-blue-500 hover:text-blue-700"
                          onClick={() => openEmailModal(res.email, res.firstName, res.lastName)}
                          title="Send Email"
                        >
                          <MdEmail size={18} />
                        </button>
                        <button
                          className="text-green-500 hover:text-green-700"
                          onClick={() => openWhatsappModal(res.phoneNumber, res.firstName, res.lastName)}
                          title="WhatsApp"
                        >
                          <MdWhatsapp size={18} />
                        </button>
                        <button
                          className="text-blue-600 hover:text-blue-800"
                          onClick={() => handleView(res._id)}
                          title="View"
                        >
                          <FaEye size={18} />
                        </button>
                        <button
                          className="text-success hover:text-green-800"
                          onClick={() => updateToggle(res)}
                          title="Edit"
                        >
                          <FaEdit size={18} />
                        </button>
                        <button
                          className="text-red-500 hover:text-red-700"
                          onClick={() => deleteData(res._id)}
                          title="Delete"
                        >
                          <MdDelete size={18} />
                        </button>
                        <button
                          className="text-purple-600 hover:text-purple-800"
                          onClick={() => handlePhoneClick(res.phoneNumber)}
                          title="Call"
                        >
                          <FaPhone size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-6 text-gray-500 font-medium">
                    No leads found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>




      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />


      <AddLead show={showAddModal} onHide={() => setShowAddModal(false)} />

      <FileUpdate
        updateModal={updateModal}
        updateToggle={updateToggle}
        updateId={updateId}
        searchDefault1={searchDefault}
      />
      <DeleteModal deleteModal={deleteModal} deleteToggle={deleteToggle} setChecked={setChecked} leadId={leadId} limits={limits} setLeadId={setLeadId} setMainPage={setMainPage} searchDefault1={searchDefault} />

      {/* WhatsApp Modal */}
      <Modal show={isWhatsappModalOpen} onHide={closeWhatsappModal}>
        <Modal.Header closeButton>
          <Modal.Title>Send WhatsApp Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Lead Name</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedLeadName}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Mobile Number</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedMobileNumber}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Select Message</Form.Label>
              <Form.Select
                className="border-2"
                value={whatsappDropdownSelection}
                onChange={(e) => {
                  setWhatsappDropdownSelection(e.target.value);
                  setErrors((prev) => ({ ...prev, dropdown: '' }));
                }}
              >
                <option value="">Select Option</option>
                {whatsAppMessage.map((msg) => (
                  <option key={msg._id} value={msg._id}>
                    {msg.title}
                  </option>
                ))}
                <option value="other">Other</option>
              </Form.Select>
              {errors.dropdown && (
                <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{errors.dropdown}</div>
              )}
            </div>

            {whatsappDropdownSelection === 'other' && (
              <div className="mb-4">
                <Form.Control
                  type="text"
                  placeholder="Please specify"
                  className="border-2"
                  value={otherMessage}
                  onChange={(e) => {
                    setOtherMessage(e.target.value);
                    setErrors((prev) => ({ ...prev, other: '' }));
                  }}
                />
                {errors.other && (
                  <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{errors.other}</div>
                )}
              </div>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeWhatsappModal}>
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4"
            onClick={handleSend}
          >
            Send
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Email Modal */}
      <Modal show={isEmailModalOpen} onHide={closeEmailModal}>
        <Modal.Header closeButton>
          <Modal.Title>Send Email Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="leadName">
              <Form.Label>Lead Name</Form.Label>
              <Form.Control
                type="text"
                value={selectedLeadName}
                readOnly
                disabled
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="emailRecipient">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                value={selectedEmailAddress}
                readOnly
                disabled
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="emailTemplateSelect">
              <Form.Label>Select Template</Form.Label>
              <Form.Select
                value={emailDropdownSelection}
                onChange={(e) => setEmailDropdownSelection(e.target.value)}
              >
                <option value="">Select Option</option>
                {emailTemplates.map((template) => (
                  <option key={template._id} value={template._id}>
                    {template.title}
                  </option>
                ))}
                <option value="custom">Custom</option>
              </Form.Select>
            </Form.Group>

            {emailDropdownSelection === 'custom' && (
              <Form.Group className="mb-3" controlId="customMessage">
                <Form.Label>Custom Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={customEmailMessage}
                  onChange={(e) => setCustomEmailMessage(e.target.value)}
                  placeholder="Type your message here"
                />
              </Form.Group>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeEmailModal}>
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4"
            onClick={handleSendEmail}
          >
            Send
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
}

